// extracted by mini-css-extract-plugin
module.exports = {"button":"AppleAuth_button__1M90g GoogleAuth_button__iiNbL","icon":"AppleAuth_icon__2Ry0f GoogleAuth_icon__2svQZ"};